<template>
  <div class="payrecorddeteilpage">
    <div class="paylistsus">
      <span class="listline"></span>
      <p class="paylisttit">
        <span class="title">缴费信息</span>
      </p>
      <div class="payliscon">
        <p>
          <span>流水号：</span>
          <span>{{chargeList.ChargeNo}}</span>
        </p>
        <p>
          <span>订单状态：</span>
          <span>{{chargeList.StateName}}</span>
        </p>
        <p>
          <span>收费金额：</span>
          <span>{{chargeList.Amount}}</span>
        </p>
        <p>
          <span>支付时间：</span>
          <span>{{chargeList.ChargeTime}}</span>
        </p>
      </div>
    </div>
    <div class="drugdeteil" v-for="item in categorychargeList">
      <span class="listline"></span>
      <p class="paylisttit">
        <span>{{item.Name}}</span>
      </p>
      <div class="payliscon" v-for="el in item.data">
        <div class="Clinicguide">
          <p>
            <span>处方号：</span>
            <span>{{el.OrderNumber}}</span>
          </p>
          <p>
            <span>就诊指引：</span>
            <span>{{el.Address}}</span>
          </p>
        </div>
        <div class="drug">
          <p class="bg">
            <span>项目名称</span>
            <span>数量</span>
            <span>总价</span>
          </p>
          <p v-for="model in el.Detail">
            <span>{{model.Name}}</span>
            <span>{{model.Quantity}}</span>
            <span>{{model.Amount}}</span>
          </p>
          <div class="amount">
            <span>总计：</span>
            <span></span>{{el.Amount}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { ChargeSuccess } from "@/services/getData.js";
  import _ from 'lodash';
  import weui from "weui.js";
  export default {
    name: "personal-payrecorddetil",
    data() {
      return {
        chargeID: this.$route.query.chargeID,
        chargeList: {},
        categorychargeList:[]
      };
    },
    created: function () {
      this.chargeSuccess();
    },
    methods: {
      chargeSuccess() {
        var loading = weui.loading('loading', {
          className: 'custom-classname',
          content: '加载中'
        });
        ChargeSuccess(this.chargeID, "").then((response) => {
          loading.hide();
          if (response.data) {
            this.chargeList = response.data;
            console.info(response.data);
             var map = {},
                  dest = [];
              for(var i = 0; i < response.data.Detail.length; i++){
                  var ai = response.data.Detail[i];
                  if(!map[ai.ItemType]){
                      dest.push({
                        ItemType: ai.ItemType,
                        Name: ai.Name,
                        data: [ai]
                     });
                      map[ai.ItemType] = ai;
                  }else{
                      for(var j = 0; j < dest.length; j++){
                          var dj = dest[j];
                          if(dj.ItemType == ai.ItemType){
                              dj.data.push(ai);
                              break;
                          }
                      }
                  }
              }
            this.categorychargeList=dest;
          }
        });
      }
    },
    filters: {
      itemFilters: function (value) {
        if (value > 0) {
          return "有号";
        }
        else {
          return "无号";
        }
      }
    }
};
</script>
<style>
.payrecorddeteilpage {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.payrecorddeteilpage .paysusicon {
  width: 100%;
  height: 2.2rem;
  background: white;
  text-align: center;
  box-sizing: border-box;
  padding: 0.32rem 0;
  font-size: 0.3rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 0.2rem;
}
.payrecorddeteilpage .paysusicon .payicon {
  width: 1.02rem;
  height: 1.07rem;
  margin: 0 auto;
  margin-bottom: 0.1rem;
}
.payrecorddeteilpage .paylistsus {
  /* padding: 0 0.2rem; */
  box-sizing: border-box;
  width: 100%;
  height: auto;
  background-color: white;
  position: relative;
  margin-bottom: 0.2rem;
}
.payrecorddeteilpage .paylisttit {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #1592e4;
  border-bottom: 0.01rem solid #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
  width: 100%;
}
.payrecorddeteilpage .payliscon {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.payrecorddeteilpage .Clinicguide {
  font-family: MicrosoftYaHei;
  font-weight: 400;
  font-size: 0.22rem;
  padding-top: 0.2rem;
  box-sizing: border-box;
}
.payrecorddeteilpage .Clinicguide>p{
    position: relative;
}
.payrecorddeteilpage .Clinicguide .seereport{
        position: absolute;
    right: 0;
    width: 1.11rem;
    height: 0.4rem;
    background: rgba(61,151,209,1);
    border-radius: 0.05rem;
    text-align: center;
    color: white;
    line-height: 0.4rem;
}
.payrecorddeteilpage .paylistsus > .payliscon > p {
  width: 100%;
  border-bottom: 0.01rem dotted #dddddd;
  height: 0.79rem;
  line-height: 0.8rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.payrecorddeteilpage .paylistsus > .payliscon > p > span:first {
  color: #333333;
  text-align: left;
}
.payrecorddeteilpage .paylistsus > .payliscon > p > span:last-child {
  color: #999999;
  text-align: right;
  float: right;
}
.medipayrecorddeteilpagecdeteilpage .paylistsus > .payliscon > p:last-child {
  border-bottom: none;
}
.payrecorddeteilpage .diagnose > div {
  width: 100%;
  border-bottom: 0.01rem dotted #dddddd;
  line-height: 0.65rem;
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.payrecorddeteilpage .diagnose > div>p:last-child{
    color: #999999 ;
}
.payrecorddeteilpage .listline {
  display: block;
  position: absolute;
  width: 0.08rem;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  top: 0;
  left: 0;
}
.payrecorddeteilpage .drugdeteil {
  font-size: 0.2rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  background: white;
  position: relative;
  margin-bottom: 0.2rem;
}
.payrecorddeteilpage .drugdeteil .drug {
  border: 0.01rem solid #dddddd;
  margin: 0.2rem 0;
}
.payrecorddeteilpage .drugdeteil .drug > p {
  display: flex;
  flex-direction: row;
  line-height: 0.35rem;
  margin-bottom: 0.21rem;
}
.payrecorddeteilpage .drugdeteil .drug > p > span:first-child {
  width: 60%;
  box-sizing: border-box;
  padding-left: 0.43rem;
}
.payrecorddeteilpage .drugdeteil .drug > p > span:nth-child(2) {
  width: 20%;
}
.payrecorddeteilpage .drugdeteil .drug > p > span:last-child {
  width: 20%;
  text-align: center;
}
.payrecorddeteilpage .drugdeteil .drug .amount {
  text-align: right !important;
  color: red;
  box-sizing: border-box;
  padding-right: 0.25rem;
  border-top: 0.01rem solid #dddddd;
  line-height: 0.6rem;
}
.payrecorddeteilpage .drugdeteil .drug .bg {
  background: #f2f2f2;
  height: 0.6rem;
  line-height: 0.6rem;
}
</style>




// WEBPACK FOOTER //
// src/components/person/personal-payrecorddetil.vue